'use client'
import { useUser } from '@/src/store/user-store'
import { useToken } from '@/src/store/token-store'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

const ignoredRoutes = [
  '/community',
  '/contact-us',
  '/data-usage',
  '/faqs',
  '/how-earnings-work',
  '/privacypolicy',
  '/termsofservice',
]

const notAllowedRoutesLoggedOut = ['/account']

export const AuthenticationCheck = () => {
  const { user, _hasHydrated, setRefreshToken } = useUser()
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()
  const { setToken } = useToken()
  const device = searchParams.get('device')
  const token = searchParams.get('token')
  const rtoken = searchParams.get('rtoken')
  if (user == null && device === 'app' && token && rtoken) {
    setToken(token)
    setRefreshToken(rtoken)
  }
  useEffect(() => {
    const device = searchParams.get('device')
    let reqFieldsReopen = user && (user?.isBusinessUser !== '1' ? (!user.dob || !user.gender || !user.countryId) : !user.countryId)
    if (user !== null && user.verifiedUser == '0' && _hasHydrated) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') { router.replace('/auth/verify?device=tv') } else { router.replace('/auth/verify') }
    } else if (user !== null &&
      user.isOnboarded == '1' &&
      _hasHydrated &&
      !ignoredRoutes.includes(pathname || '') && pathname === '/auth/login' && (user.interestIds.length === 0 || user.languageIds.length === 0)) {
      router.replace('/auth/verify/onboarding')
    } else if (user !== null &&
      reqFieldsReopen &&
      _hasHydrated &&
      !ignoredRoutes.includes(pathname || '')) {
      router.replace('/auth/verify/onboarding')
    } else if (
      user !== null &&
      user.isOnboarded == '0' &&
      _hasHydrated &&
      !ignoredRoutes.includes(pathname || '')
    ) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') { router.replace('/auth/verify/onboarding?device=tv') } else { router.replace('/auth/verify/onboarding') }

    } else if (
      user === null &&
      notAllowedRoutesLoggedOut.includes(pathname || '') &&
      _hasHydrated
    ) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') {
        const redirectUrl = localStorage.getItem('redirectUrl') || '/home?device=tv'
        router.replace(redirectUrl)
      } else {
        const redirectUrl = localStorage.getItem('redirectUrl') || '/home'
        console.log("userIN2", user);
        router.replace(redirectUrl)
      }
    }
  }, [user, router, _hasHydrated, pathname])

  return <></>
}